// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_hv","galleryItem_borderTopRadius":"c-o_hw","galleryItem__image":"c-o_hx","galleryItem__image_withBlur":"c-o_hy"};